import { titanApi } from "../../services/API/titanApi";
import { setAashtoState } from "../../store/slices/aashtoSlice";
import { setAeussereState } from "../../store/slices/aeussereSlice";
import { setAngepassteBemessungslastState } from "../../store/slices/angepassteBemessungslastSlice";
import { setBelastungsartUndRichtungState } from "../../store/slices/belastungsartUndRichtungSlice";
import { setBemessungenMikropfaehleState } from "../../store/slices/bemessungenMikropfaehleSlice";
import { setBemessungslastGruppeGesamtState } from "../../store/slices/bemessungslastGruppeGesamtSlice";
import { setBemessungslastState } from "../../store/slices/bemessungslastSlice";
import { setBohrkronendurchmesserState } from "../../store/slices/bohrkronendurchmesserSlice";
import { setCreatedAt, setDeckblattState } from "../../store/slices/deckblattSlice";
import { setFhwaState } from "../../store/slices/fhwaSlice";
import { setFrontendZustandState } from "../../store/slices/frontendZustandSlice";
import { setInnereState } from "../../store/slices/innereSlice";
import { setPileHeadConstructionState } from "../../store/slices/pileHeadConstructionSlice";
import { setProjectId, setProjectName } from "../../store/slices/projectSlice";
import { setTraggliedState } from "../../store/slices/traggliedSlice";
import { setLvTextState } from "../../store/slices/lvTextSlice";
import { setEpdState } from "../../store/slices/epdSlice";
import { store } from "../../store/store";
import i18n from "../../i18n";

const saveProject = async ({ id, pname }) => {
  const {
    _persist: { version },
    frontendZustand,
    bemessungslast,
    selectedTragglied,
    bohrkronendurchmesser,
    belastungsartUndRichtung,
    bemessungslastGruppeGesamt,
    angepassteBemessungslast,
    deckblatt,
    bemessungenMikropfaehle,
    pileHeadConstruction,
    innere,
    aeussere,
    aashto,
    fhwa,
    lvText,
    epd,
  } = store.getState();

  let project = {
    version,
    projectName: pname,
    selectedTragglied,
    bemessungslast,
    bohrkronendurchmesser,
    belastungsartUndRichtung,
    bemessungslastGruppeGesamt,
    bemessungenMikropfaehle,
    frontendZustand,
    angepassteBemessungslast,
    aeussere,
    deckblatt,
    pileHeadConstruction,
    innere,
    aashto,
    fhwa,
    lvText,
    epd,
  };

  if (id !== "") {
    await store.dispatch(
      titanApi.endpoints.updateProject.initiate({
        _id: id,
        ...project,
      })
    );
    // TODO: show that new Projectdata was loaded
  } else {
    const { data } = await store.dispatch(
      titanApi.endpoints.saveNewProject.initiate({
        version,
        ...project,
      })
    );

    if (data) {
      store.dispatch(setProjectId(data._id));
      store.dispatch(setProjectName(data.projectName));
    }
    // TODO: show that Projectdata was updated
  }
};

const loadProject = ({ id }) => {
  store
    .dispatch(titanApi.endpoints.getProjectById.initiate({ id }, { track: false }))
    .unwrap()
    .then((res) => {
      // Fill store
      store.dispatch(setFrontendZustandState(res.frontendZustand));
      store.dispatch(setBemessungslastState(res.bemessungslast));
      store.dispatch(setTraggliedState(res.selectedTragglied));
      store.dispatch(setBohrkronendurchmesserState(res.bohrkronendurchmesser));
      store.dispatch(setBelastungsartUndRichtungState(res.belastungsartUndRichtung));
      store.dispatch(setBemessungslastGruppeGesamtState(res.bemessungslastGruppeGesamt));
      store.dispatch(setAngepassteBemessungslastState(res.angepassteBemessungslast));
      store.dispatch(setDeckblattState(res.deckblatt));
      store.dispatch(setBemessungenMikropfaehleState(res.bemessungenMikropfaehle));
      store.dispatch(setPileHeadConstructionState(res.pileHeadConstruction));
      store.dispatch(setInnereState(res.innere));
      store.dispatch(setAeussereState(res.aeussere));
      store.dispatch(setAashtoState(res.aashto));
      store.dispatch(setEpdState(res.epd));
      store.dispatch(setLvTextState(res.lvText));
      if (res.fhwa) store.dispatch(setFhwaState(res.fhwa));

      store.dispatch(setProjectId(res?._id ?? ""));
      store.dispatch(setProjectName(res?.projectName ?? ""));
      store.dispatch(setCreatedAt(new Date(Date.now()).toLocaleDateString(i18n.language)));
    })
    .catch((err) => {
      console.error(err);
      // TODO: display failure for loading
    });
};

export { saveProject, loadProject };
